var template = window.location.pathname.split('/').filter(e => e != "");
template = template[template.length-1];
const filters_object = [];
let products_to_sort = ''
let value = document.getElementById("select_sort");
const url_base = `${window.location.origin}${window.location.pathname}`;
var data = ""
let items_paginate = parseInt(document.getElementsByClassName("content_filter")[0].getAttribute("data_limit"));
let aux = []
let products_to_filter_variant = "";

function loadFilters() {
  
  //data = (template == 'all') ? JSON.parse(window.localStorage.getItem('products_to_filter')).products : JSON.parse(window.localStorage.getItem('products_collection')).products;
  data = (template == 'all') ? JSON.parse(window.localStorage.getItem('products_to_filter')).products : JSON.parse(window.localStorage.getItem('products_collection')).products;
  (window.location.search.indexOf("?filter=") > -1) ? load_tags_active() : false

  let nav = document.getElementsByClassName("body_filters")[0];
  setTimeout( () => {
    nav.classList.remove("load_filter");
    document.getElementById("render_products_collection").classList.remove("load_filter");
  }, 1000);

  console.log( "SL : "+ data );

}
/*resetear filtros*/
const reset = () => {
  filters_object.map(filter => {
    filter.state = false
    filter.elem.checked = false
  });
  changeUrl(filters_object)
}

/* funcion que ordena productos por diferentes criterios*/
const sort_type = e => {
  let products = (products_to_sort.length > 0) ? products_to_sort : data
  if (e.value === 'ascendente') {
    products.sort(function (a, b){
      return (a.variants[0].price - b.variants[0].price)
    })
  } else if(e.value === 'descendente') {
    products.sort(function (a, b){
      return (b.variants[0].price - a.variants[0].price)
    })
  } else if (e.value === 'title-ascending') {
    products.sort(function (a, b){
      return a.title.localeCompare(b.title)
    })
  } else if(e.value === 'title-descending') {
    products.sort(function (a, b){
      return b.title.localeCompare(a.title)
    })
  } else if (e.value === 'created-ascending') {
    products.sort(function (a, b){
      return new Date(a.published_at) - new Date(b.published_at)
    })
  } else if (e.value === 'created-descending') {
      products.sort(function (a, b){
        return new Date(b.published_at) - new Date(a.published_at)
      })
  }
  return products;
}

/* esta función es para cuando el usuario no selecciona ningun filtro
y solo cambia el select de dropdown de orden*/
async function sort_products(e) {
  let response = await sort_type(e)
  show_products_filter(response)
}
/* filtrar por precio */
const filter_by_price = products => {
  let values = filters_object.filter( filter => filter.id == 'Precio_filter' && filter.state == true).map( filter => filter.name)[0]
  if (values != undefined) products = products.filter( product => product.variants[0].price >= parseInt(values.split('-')[0]) && product.variants[0].price <= parseInt(values.split('-')[1]))
  return products
}

/* Esta es la función encargada de pintar cada elemento que contiene la data ya filtrada*/
const show_products_filter = products => {
  products_to_sort = products
  /*Se manda a llamar la función que ordena la data ya filtrada por a-z, z-a, etc*/
  products_to_sort = sort_type(value)
  /*ahora a la función que filtra*/
  products = filter_by_price(products);
  let content = []
  var isUserLogged = (localStorage.getItem('isUserLogged') === 'true');
  products.map( product => {
    let button = isUserLogged ? `<input type="button" class="btn-product" onclick="document.getElementById('form${product.variants[0].id}').click()" value="Añadir al pedido"/>` : '';

    let product_container = `<div class="row container product-row">
                                  <div class="col-sm-2 productImage">
                                      <div class="product-collection_container">
                                          <a href="/products/${product.handle}"><img class="product-img" src="z" alt="Product image"></a>
                                      </div>
                                  </div>
                                  <div class="col-sm-4 productTitle">

                                      <a href="/products/${product.handle}">
                                        <p class="product-text">${product.title}</p>
                                        <p class="product-text price d-md-none">$${product.variants[0].price}</p>
                                      </a>
                                      <div class="collection-compatible-models" id="compatible_${product.handle}">
                                        <img class="blue-filter icon-png" src="//cdn.shopify.com/s/files/1/0080/5345/6993/t/4/assets/icon-car_small.png?22099">
                                      </div>
                                  </div>
                                  <div class="col-sm-2 productFormContainer">
                                      <p class="product-text">
                                          </p><form action="/cart/add" method="post">
                                              <input type="hidden" name="id" value="${product.variants[0].id}">
                                              <input id="quantity" min="1" name="quantity" type="number" value="1">
                                              <input id="form${product.variants[0].id}" class="d-none" type="submit" value="Añadir al pedido">
                                          </form>
                                          <p></p>
                                      </div>
                                      <div class="col-sm-4 productFormContainer">
                                        <div class="row">
                                          <div class="col-sm-12 col-md-6">
                                              <p class="product-text price d-sm-none d-md-block">$${product.variants[0].price}
                                              </p>
                                          </div>
                                          <div class="col-sm-12 col-md-6">
                                                <span class="existencias-label">Existencia(s): </span>
                                                ${ button }
                                              </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  <div>
                                </div>
                                <span class="line"></span>`
    content.push(product_container);
  })
  aux = []
  let tam = content.length / items_paginate;
  if (tam == items_paginate) aux = content
  else {
    let total_items_for_page = items_paginate
    for (var i = 0; i < content.length;i = i + items_paginate) {
      aux.push(content.slice(i, total_items_for_page));
      total_items_for_page = total_items_for_page + items_paginate
    }
    total_items_for_page = items_paginate
  }

  const error = () => {
    document.getElementById("render_products_collection").innerHTML =
    `<div class="text-center">
        <h2 class="mt-5 title_h2_black text-center">No hay productos que coincidan con su busqueda</h2>
        <div class="col-md-4 m-auto">
          <button onclick="reset();" class="button_golden_solid mt-3 text-uppercase"> Resetear filtros </button>
        </div>
    </div>`
    document.getElementById("pagination").style.opacity = '0';
  }
  products_to_filter_variant = products;
  (aux.length == 0) ? error() : write_with_paginate();
}

function write_with_paginate(page=0,products) {
  try {
    let paginate = document.getElementById("pagination");
    paginate.style.opacity = '1';
    let pages = []
    for (var i = 0; i < aux.length; i++) {
      let num_paginate = `<span class="page ${(page == i) ? 'current' : ''}" onclick="write_with_paginate(${i})">${i+1}</span>`;
      pages.push(num_paginate);
    }

    let pagesPrincipales = pages.slice(page,page+3)
    paginate.innerHTML = (pages.length > 3) ? `${pagesPrincipales.join("")}<span class="mr-2">...</span>${pages[pages.length-1]}<span class="next"><a onclick="write_with_paginate(${page+1});">Siguiente</a></span>` : pages.join("");
    if (page > 0) {
      if(page == pages.length-1) {
        paginate.innerHTML = `<span class="prev"><a onclick="write_with_paginate(${page-1})">Anterior</a></span>${pages[0]}<span class="mr-2">...</span>${pages.slice(page-2,page+1).join("")}`
      } else {
        if (page+3 >= pages.length-1) {
          paginate.innerHTML = `<span class="prev"><a onclick="write_with_paginate(${page-1})">Anterior</a></span>${pages[0]}${pagesPrincipales.join("")}`
        } else {
          paginate.innerHTML = (pages.length > 3) ? `<span class="prev"><a onclick="write_with_paginate(${page-1})">Anterior</a></span>${pages[0]}${pagesPrincipales.join("")}<span class="mr-2">...</span>${pages[pages.length-1]}<span class="next"><a onclick="write_with_paginate(${page+1});">Siguiente</a></span>` : pages.join("");
        }
      }
    }
  }
  catch(err) {}
    setTimeout(
      document.getElementById("render_products_collection").innerHTML = aux[page].join("")
      ,300);
  writeVariants();
}

function writeVariants() {
  products = products_to_filter_variant;
  let aux2 = []

  let obj_filter = JSON.parse(sessionStorage.getItem("filters_obj"))

  let url_base = window.location.origin;
  let aux_url = []
  obj_filter.map( obj => {
    console.log(obj.id);
    if (obj.id.indexOf("Año") > -1) {
      obj.url_fetch = `year_${obj.name}`;
    }

   console.log( "fetch : " + obj.url_fetch );
    
    
    aux_url.push(obj.url_fetch.toLowerCase())
    
  })
  let url_to_fetch = `${url_base}/${aux_url.join("+")}`
  console.log(url_to_fetch);

  products.map( product => {
    let compatible = product.tags.map( tag => {
      if(tag.indexOf("compatible_") > -1) {
        let div = document.createElement("div");
        div.classList.add('model-container');
        div.style.margin = "3px"
        let elem =  `${tag.split("_")[1]}`
        div.innerHTML = elem;
        aux2.push(div)
      }
    });
    let id = `compatible_${product.handle}`;
    let container = document.getElementById(id);
    aux2.map( elem => {
      if (container != undefined || container != null ) container.appendChild(elem);
    })
    aux2 = []
  })
}


let aux1= [];
let aux2 = [];
let aux3 = [];
/*Esta función filtra la data que se encuentra cargada en locaStorage */
const filter_products = filters => {
  var productos_already_filters = data
  filters.map( tag => {
    //tag = tag.split("_")[1]
    productos_already_filters = productos_already_filters.filter( product => {
        let tags = product.tags.join().toLowerCase();

        product.show = (tags.indexOf(tag.toLowerCase()) > -1) ? true : false
        return product.show != false
    })
  })
  show_products_filter(productos_already_filters)
}

const load_tags_active = () => {
  let tags = window.location.search.split("filter=")[1].split("+")
  tags.map(tag => {
    let filter_element = {
      id: '',
      name: tag,
      state: true,
      elem: document.getElementById(tag)
    }
    if (filter_element.elem != undefined && filter_element.elem != null) {
      filter_element.elem.checked = true;
      filter_element.id = filter_element.elem.name;
      filters_object.push(filter_element)
    }
  })
  filter_products(tags)
}


/*Esta función es la que se encarga de generar el arreglo que contendrá los tags que estan activos */
const changeUrl = (filters) => {
  let tags_ok = filters.filter( filter => filter.state != false && filter.id != 'Precio_filter').map( tag => tag.name)
  let newUrl = (tags_ok.length > 0) ? `${url_base}?filter=${tags_ok.join('+')}` : url_base;
  history.replaceState({},'', newUrl);
  filter_products(tags_ok)
}


/*Esta es la primer función que se ejecuta en el onclick y crea un json con cada tag
que es clickeado, ya evita que se repitan tags mediante el id*/
function getValueTag(e) {
  let action = (e.checked) ? true : false;
  let filter_element = {
    id: e.name,
    name: e.value,
    state: action,
    url_fetch: e.name.split("_")[0]+"_"+e.value,
    elem: e
  }

  console.log("FLTR : "+ JSON.stringify(filter_element));
  if(filters_object.length == 0 ) filters_object.push(filter_element)
  else {
    let val = filters_object.map(filter => {
      if (filter.id == e.name) {
        filter.name = e.value
        filter.elem.checked = false;
        filter.elem = e
        if (filter.name == e.value) {
          filter.state = (action) ? true : false
          filter.elem.checked = (filter.state) ?  true : false
        }
        return true
      }
    });
    if (!val.includes(true)) filters_object.push(filter_element)
  }

  console.log( " filters_object  "+ JSON.stringify(filters_object) );
  
  sessionStorage.setItem("filters_obj", JSON.stringify(filters_object))
  changeUrl(filters_object);
}

window.onload = function() { loadFilters();}
